export default {
  methods: {
    setPrimaryColour(colors) {
      const primary = colors.primary;
      const secondary = colors.primary;

      const companyNameDom = document.querySelector(".company-name");
      companyNameDom.style.color = primary;

      const socialCtas = document.querySelectorAll(".third-party-access");
      socialCtas.forEach(cta => {
        cta.style.background = `${primary}15`;
        cta.style.borderColor = `${primary}40`;
      });

      const termsLinks = document.querySelectorAll(".authx-form a");
      termsLinks.forEach(link => {
        link.style.color = secondary;
      });

      const formFooterCtas = document.querySelectorAll(
        ".authx-form .form-footer span"
      );
      formFooterCtas.forEach(cta => {
        cta.style.color = secondary;
      });

      const buttons = document.querySelectorAll(
        ".authx-button.el-button--primary"
      );
      buttons.forEach(button => {
        button.style.background = primary;
        button.style.borderColor = primary;
      });
    }
  }
};
